<template>
  <div>
    <el-select
      v-if="!useVuetify"
      v-model="selectedId"
      @change="do_change"
      :placeholder="placeholder"
      :size="size"
    >
      <el-option v-if="allowAll" :value="0" :label="'Any Category'"></el-option>
      <el-option
        v-for="option in sourceDetails"
        :value="option.id"
        :key="option.id"
        :label="option.label"
      >
      </el-option>
    </el-select>
    <v-select
      v-else
      v-model="selectedId"
      @update:model-value="do_change"
      :label="label"
      :placeholder="placeholder"
      :items="selectOptions"
      :density="vuetifyDensity"
      hide-details="auto"
      variant="outlined"
      :clearable="clearable"
    ></v-select>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'leadSourceDetailSelect',
  computed: {
    ...mapGetters('leadSource', ['getLeadSourceDetails']),
    sourceDetails() {
      return this.getLeadSourceDetails(this.leadSourceId);
    },
    selectOptions() {
      const options = this.sourceDetails.map(detail => ({
        value: detail.id,
        title: detail.label
      }));
      
      if (this.allowAll) {
        options.unshift({ value: 0, title: 'Any Category' });
      }
      
      return options;
    },
    vuetifyDensity() {
      const densityMap = {
        'default': 'default',
        'small': 'compact',
        'mini': 'comfortable'
      };
      return densityMap[this.size] || 'compact';
    }
  },
  props: {
    leadSourceId: {
      type: Number,
      required: true,
    },
    value: {
      type: Number,
    },
    initialId: {
      type: Number,
      required: false,
    },
    size: {
      type: String,
      default: () => {
        return 'small';
      },
    },
    placeholder: {
      type: String,
      required: false,
      default: () => {
        return 'Select a detail';
      },
    },
    label: {
      type: String,
      required: false,
      default: () => {
        return 'Lead Source Detail';
      },
    },
    allowAll: {
      type: Boolean,
      required: false,
      default: () => {
        return false;
      },
    },
    useVuetify: {
      type: Boolean,
      required: false,
      default: false
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      selectedId: undefined,
    };
  },
  watch: {
    initialId(id) {
      this.selectedId = id;
    },
    value(n) {
      this.selectedId = parseInt(n);
    },
  },
  async created() {
    if (this.value != undefined) {
      this.selectedId = parseInt(this.value);
    }
    if (this.initialId) {
      this.selectedId = this.initialId;
    }
  },
  methods: {
    do_change() {
      const lsDetail = this.sourceDetails.find(
        (s) => s.id == this.selectedId
      );
      this.$emit('update:leadSourceDetail', lsDetail);
      this.$emit('update:modelValue', lsDetail?.id);
      this.$emit('change', lsDetail?.id);
    },
  },
};
</script>